import $ from 'cash-dom';
import spinner from '../../../components/spinner';
import StringHelper from '../../../components/StringHelper';
import ObjectHelper from '../../../components/ObjectHelper';

const ARTIFICIAL_WAITING_TIME = 350;

class PgFilter {
	constructor() {
		this._$filtersHolder = null;
		this._allFilters = null;
		this._$options = null;
		this._$clean = null;
		this._$vendorsContainer = null;
		this._$vendorsQuotes = null;
		this._$sort = $('.sort-select .styleable-select-list');
		this._defaultFilters = null;
		this._defaultSortBy = null;
	}

	/**
	 * @param {[{}]} defaultFilters
	 * @return {PgFilter}
	 */
	setDefaultFilters(defaultFilters) {
		this._defaultFilters = defaultFilters;

		return this;
	}

	/**
	 * @param {string} sortBy 'price' | 'recommended'
	 * @return {PgFilter}
	 */
	setDefaultSortBy(sortBy) {
		this._defaultSortBy = sortBy;

		return this;
	}

	init() {
		this._$filtersHolder = $('.filters-holder.pg-filters');
		this._allFilters = this._$filtersHolder.data('filters');

		if (!this._$filtersHolder.length || !this._allFilters) {
			return;
		}

		this._offHandlers();

		this._$vendorsContainer = $('.vendors-container');
		this._$vendorsQuotes = this._$vendorsContainer.find('.ppc-single-vendor');

		this._$options = this._$filtersHolder.find('.options .option');
		this._$clean = $('.filters-container .clean-btn');
		this._$sort = $('.results-page .sort-container #sort');

		this._$options.on('click', this._filter);
		this._$clean.on('click', this._clean);
		this._$sort.on('change', this._sort);

		this._handleDefaultFilters();
		this._handleDefaultSort();
		this._attachDocumentPgEvents();
	}

	_offHandlers() {
		if (this._$options) {
			this._$options.off('click', this._filter);
		}

		if (this._$clean) {
			this._$clean.off('click', this._clean);
		}

		if (this._$sort) {
			this._$sort.off('change', this._sort);
		}
	}

	_handleDefaultFilters() {
		if (!this._defaultFilters) {
			return;
		}

		this._setFilters(this._defaultFilters);
	}

	_handleDefaultSort() {
		if (!this._defaultSortBy) {
			return;
		}

		this._processSorting(this._defaultSortBy);
	}

	_setFilters(filters) {
		this._$options.each((i, option) => {
			const $option = $(option);

			const optionFilterValue = this._formatFilterValue($option.data('value'));
			const filterValues = filters[$option.data('name')];

			if (Array.isArray(filterValues) && filterValues.includes(optionFilterValue)) {
				this._addOptionActive($option);
			} else {
				this._removeOptionActive($option);
			}
		});

		this._filterVendorsQuotes();
	}

	_formatFilterValue(filterValue) {
		if (filterValue === 'Infinity') {
			return filterValue;
		}

		return StringHelper.isNumeric(filterValue) ? +filterValue : filterValue;
	}

	_attachDocumentPgEvents() {
		$(document).on('pg-set-filters', (e, {filters}) => {
			this._processWithArtificialWating(() => this._setFilters(filters));
		});

		$(document).on('pg-clear-filters', (e) => {
			this._processWithArtificialWating(() => this._clean(e));
		});

		$(document).on('pg-sort', (e, {sortBy}) => {
			this._processWithArtificialWating(() => this._setSortValue(sortBy));
		});
	}

	_processWithArtificialWating(callbackFn) {
		spinner.show();
		callbackFn();

		setTimeout(() => {
			spinner.hide();
		}, ARTIFICIAL_WAITING_TIME);
	}

	_setSortValue(sortBy) {
		this._$sort.find(`.option[value="${sortBy}"]`).trigger('click');
	}

	_filter = (e) => {
		e.preventDefault();
		const $option = $(e.currentTarget);

		spinner.show();

		setTimeout(() => {
			this._processFilters($option);
			spinner.hide();
		}, ARTIFICIAL_WAITING_TIME);
	}

	_processFilters($option) {
		if ($option.hasClass('active')) {
			this._removeOptionActive($option);
		} else {
			this._addOptionActive($option);
		}

		this._filterVendorsQuotes();
	}

	_addOptionActive($option) {
		$option.addClass('active');
		$option.prev().addClass('before-active');
	}

	_removeOptionActive($option) {
		$option.removeClass('active');
		$option.prev().removeClass('before-active');
	}

	_removeAllActiveClasses() {
		this._$options.removeClass('active').removeClass('before-active');
	}

	_getSelectedFilters() {
		const selectedFilters = {};

		this._$options.closest('.options').find('.option.active').each((i, option) => {
			const $option = $(option);
			ObjectHelper.addAsArrayElement(selectedFilters, $option.data('name'), $option.data('value'));
		});

		return selectedFilters;
	}

	/**
	 * Returns the vendors container, re-querying the DOM when it has not been
	 * resolved yet (the results markup is injected by AJAX after page load).
	 *
	 * @return {*}
	 */
	_ensureVendorsContainer() {
		if (!this._$vendorsContainer || !this._$vendorsContainer.length) {
			this._$vendorsContainer = $('.vendors-container');
			this._$vendorsQuotes = this._$vendorsContainer.find('.ppc-single-vendor');
		}

		return this._$vendorsContainer;
	}

	_filterVendorsQuotes() {
		const selectedFilters = this._getSelectedFilters();
		// TODO Do we need the vendorsOptionsOrderData?
		const vendorsOptionsOrderData = [];
		let visibleItemsIndex = 0;

		const vendorQuotes = this._ensureVendorsContainer().find('.ppc-single-vendor');

		vendorQuotes.each((i, vendorQuote) => {
			const $vendorQuote = $(vendorQuote);
			const quoteFilters = $vendorQuote.data('filters');

			if (!quoteFilters) {
				return;
			}

			if (this.matchesFilters(quoteFilters, selectedFilters)) {
				$vendorQuote.removeClass('hidden');

				vendorsOptionsOrderData.push({
					position_id: visibleItemsIndex++,
					vendorTitle: $vendorQuote.data('vendor-title'),
					vendor_id: $vendorQuote.data('vendor-id'),
				});
			} else {
				$vendorQuote.addClass('hidden');
			}
		});

		this._sendBiEvents(vendorsOptionsOrderData);

		$(document).trigger('pg-filters-applied', {filters: selectedFilters});
	}

	/**
	 * @param {Object} quoteFilters Quote values by filter name, e.g. {'deductible-choices': '250', vendor: 3103}
	 * @param {Object} selectedFilters Selected values by filter name, see _getSelectedFilters()
	 * @return {boolean}
	 */
	matchesFilters(quoteFilters, selectedFilters) {
		for (const [quoteFilterName, quoteFilterValue] of Object.entries(quoteFilters)) {
			const selectedFilterValues = selectedFilters[quoteFilterName];

			if (Array.isArray(selectedFilterValues) && !selectedFilterValues.includes(this._formatFilterValue(quoteFilterValue))) {
				return false;
			}
		}

		return true;
	}

	_getFilterRange(filterName, filterValue) {
		const currentFilters = this._allFilters[filterName];
		let currentFilterIndex = 0;

		for (let i = 0; i < currentFilters.length; ++i) {
			if (+currentFilters[i] === +filterValue) {
				currentFilterIndex = i;
				break;
			}
		}

		const prev = currentFilters[currentFilterIndex - 1];
		const rangeFrom = prev === undefined ? 0 : prev;

		return [+rangeFrom, +filterValue];
	}

	_sendBiEvents(vendorsOptionsOrderData) {
		// TODO implement
	}

	_clean = (e) => {
		e.preventDefault();

		spinner.show();

		setTimeout(() => {
			this._removeAllActiveClasses();
			this._filterVendorsQuotes();

			spinner.hide();
		}, ARTIFICIAL_WAITING_TIME);
	}

	_sort = (e) => {
		const $current = $(e.currentTarget);

		spinner.show();

		setTimeout(() => {
			this._processSorting($current.val());
			spinner.hide();
		}, ARTIFICIAL_WAITING_TIME);
	}

	_processSorting(sortBy) {
		const sortByDataParam = this._getSortByDataParam(sortBy),
			$vendorsContainer = this._ensureVendorsContainer(),
			vendorQuotes = $vendorsContainer.find('.ppc-single-vendor');

		let sorted;

		if (sortByDataParam === 'recommended') {
			sorted = this._sortByRecommended(vendorQuotes);
		} else {
			sorted = Object.values(vendorQuotes).sort((a, b) => {
				if (sortByDataParam === 'coverage') {
					return parseFloat($(b).data(sortByDataParam)) - parseFloat($(a).data(sortByDataParam));
				}
				return parseFloat($(a).data(sortByDataParam)) - parseFloat($(b).data(sortByDataParam));
			});
		}

		$vendorsContainer.empty();
		for (const sortedElement of sorted) {
			$vendorsContainer.append(sortedElement);
		}
	}

	_getSortByDataParam(sortBy) {
		let sortByDataParam;

		switch (sortBy) {
			case 'price':
				sortByDataParam = 'price';
				break;
			case 'coverage':
				sortByDataParam = 'coverage';
				break;
			case 'recommended':
			default:
				sortByDataParam = 'recommended';
		}

		return sortByDataParam;
	}

	_applyFilters() {
		this._setFilters(this._getSelectedFilters());
	}

	_getCurrentSortBy() {
		let currentSortByValue = $('.sort-select .styleable-select-current .select-label').html(),
			currentSortBy;

		switch (currentSortByValue) {
			case 'Price: Low to High':
				currentSortBy = 'price';
				break;
			case 'Recommended':
			default:
				currentSortBy = 'recommended';
		}

		return currentSortBy;
	}

	_sortByRecommended(vendorQuotes) {
		const annualLimitOrder = { '5000': 0, '10000': 1, '15000': 2, 'Unlimited': 3 };
		const reimbursementOrder = { '70': 0, '80': 1, '90': 2 };
		const deductibleOrder = { '100': 0, '250': 1, '500': 2, '750': 3, '1000': 4 };

		const positionMap = {};
		for (const [key, data] of Object.entries(aloomaVars.ppc_vendors_order || {})) {
			positionMap[data.vendor_id] = data.position_id;
		}

		return [...vendorQuotes].sort((a, b) => {
			const pricingA = JSON.parse(a.dataset.pricing);
			const pricingB = JSON.parse(b.dataset.pricing);

			const posA1 = annualLimitOrder[String(pricingA.coverage).trim()] ?? Number.MAX_SAFE_INTEGER;
			const posB1 = annualLimitOrder[String(pricingB.coverage).trim()] ?? Number.MAX_SAFE_INTEGER;
			if (posA1 !== posB1) return posA1 - posB1;

			const posA2 = reimbursementOrder[String(pricingA.reimbursement).trim()] ?? Number.MAX_SAFE_INTEGER;
			const posB2 = reimbursementOrder[String(pricingB.reimbursement).trim()] ?? Number.MAX_SAFE_INTEGER;
			if (posA2 !== posB2) return posA2 - posB2;

			const posA3 = deductibleOrder[String(pricingA.deductible).trim()] ?? Number.MAX_SAFE_INTEGER;
			const posB3 = deductibleOrder[String(pricingB.deductible).trim()] ?? Number.MAX_SAFE_INTEGER;
			if (posA3 !== posB3) return posA3 - posB3;

			const vendorIdA = parseInt(a.dataset.vendorId, 10);
			const vendorIdB = parseInt(b.dataset.vendorId, 10);

			const posA4 = positionMap[vendorIdA] ?? Number.MAX_SAFE_INTEGER;
			const posB4 = positionMap[vendorIdB] ?? Number.MAX_SAFE_INTEGER;
			return posA4 - posB4;
		});
	}
}

const pgFilter = new PgFilter();
export default pgFilter;
